// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Y6-z"};